import styled from 'styled-components';

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto 40px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  height: 100%;
  flex-grow: 1;

  @media (max-width: 800px) {
    gap: 20px;
  }
`;

export default Content;
